export default function windowOnViewPromise() {
    return new Promise(res => {
        if (isDocVisible()) {
            res(true);
        } else {
            document.addEventListener('visibilitychange', handler);
        }
        function handler() {
            if (isDocVisible()) {
                res(true);
                document.removeEventListener('visibilitychange', handler);
            }
        }
    });
}

function isDocVisible() {
    return document.visibilityState === 'visible';
}
